import {
  CircularProgress,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import PropTypes from 'prop-types';
import * as React from 'react';
import * as Redux from 'react-redux';

import { estatus } from '../../constants/FieldsConst';
import { validFielddHelper } from '../../helpers/ValidFieldsHelper';
import { allEstatusAction } from '../../modules/sistema/estatus/EstatusAction';

const EstatusField = ({
  onChange,
  required,
  value,
  helperText,
  error,
  disabled,
  allowIds = [],
  isEstatus = false,
}) => {
  const dispatch = Redux.useDispatch();
  const estatusStore = Redux.useSelector((state) => state.estatus);

  const [options, setOptions] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  function getData() {
    let list = estatusStore.all;
    if (isEstatus) {
      list = list.filter((item) => {
        return isEstatus && (item.id === 1 || item.id === 2);
      });
    }

    if (allowIds.length > 0) {
      list = list.filter((item) => allowIds.includes(item.id));
    }

    setOptions(list);
  }

  React.useEffect(() => {
    const fetchData = async () => {
      if (estatusStore.all.length === 0) {
        setLoading(true);
        await allEstatusAction(dispatch);
      } else {
        getData();
      }
      setLoading(false);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [estatusStore.all]);

  const xName = 'Estatus';

  return loading ? (
    <CircularProgress color="inherit" size={20} />
  ) : (
    <FormControl
      fullWidth
      error={error}
      size="small"
      required={required}
      disabled={disabled}
    >
      <InputLabel id={estatus.name}>{xName}</InputLabel>
      <Select
        labelId={estatus.name}
        id={estatus.name}
        value={value}
        label={xName}
        onChange={onChange}
      >
        {options.map((item, index) => {
          return (
            <MenuItem key={`estatus-${index}`} value={item.id}>
              {item.nombre}
            </MenuItem>
          );
        })}
      </Select>
      {error && (
        <FormHelperText>
          {helperText ?? error ? validFielddHelper(1) : null}
        </FormHelperText>
      )}
    </FormControl>
  );
};

EstatusField.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.func.isRequired,
};

export default EstatusField;
